import { render, staticRenderFns } from "./MessageOverlay.vue?vue&type=template&id=5045a3f4&scoped=true&"
import script from "./MessageOverlay.vue?vue&type=script&lang=js&"
export * from "./MessageOverlay.vue?vue&type=script&lang=js&"
import style0 from "./MessageOverlay.vue?vue&type=style&index=0&id=5045a3f4&prod&scoped=true&lang=css&"
import style1 from "./MessageOverlay.vue?vue&type=style&index=1&id=5045a3f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5045a3f4",
  null
  
)

export default component.exports